var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({
    attrs: {
      "mode": "view"
    },
    scopedSlots: _vm._u([{
      key: "연락처",
      fn: function () {
        return [_vm._v(" ***-****-**** ")];
      },
      proxy: true
    }, {
      key: "날짜",
      fn: function () {
        var _vm$value, _vm$value$applyDate, _vm$value$applyDate$t;
        return [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$applyDate = _vm$value.applyDate) === null || _vm$value$applyDate === void 0 ? void 0 : (_vm$value$applyDate$t = _vm$value$applyDate.toDate) === null || _vm$value$applyDate$t === void 0 ? void 0 : _vm$value$applyDate$t.call(_vm$value$applyDate)) + " ")];
      },
      proxy: true
    }, {
      key: "장비",
      fn: function () {
        var _vm$value2, _vm$value2$equipments;
        return [_vm._v(" " + _vm._s((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$equipments = _vm$value2.equipments) === null || _vm$value2$equipments === void 0 ? void 0 : _vm$value2$equipments.join(", ")) + " ")];
      },
      proxy: true
    }, {
      key: "신청상태",
      fn: function () {
        var _vm$APPLICATION_STATU, _vm$value3;
        return [_vm._v(" " + _vm._s((_vm$APPLICATION_STATU = _vm.APPLICATION_STATUS[(_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : _vm$value3.status]) === null || _vm$APPLICATION_STATU === void 0 ? void 0 : _vm$APPLICATION_STATU.text) + " ")];
      },
      proxy: true
    }])
  }, 'vertical-form-table', {
    value: _vm.value,
    items: _vm.items
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }